import "./Signin.css";

// Local
import AuthCard from "../../components/UI/Cards/AuthCard";
import {
  Button,
  Container,
  InputField,
  Notifications,
  Spinner,
  Text,
} from "@jds/core";
import { InputAdornment, TextField } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import useInput from "../../hooks/use-input";
import { validateEmail, validatePhoneNumber } from "../../util/validation";
import useApiHttp from "../../hooks/use-http";
import { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";

import Otp from "./Otp";

export default function Signin() {
  const [selectedCountry] = useState(0);
  const [authData, setAuthData] = useState(null);
  const [emailMode, setEmailMode] = useState(false);
  // const [email, setEmail] = useState("");
  // const [emailError, setEmailError] = useState(false);
  const [deviceKey, setDeviceKey] = useState(0);
  const phoneInputRef = useRef(null);

  const countryCodeItems = [
    { name: "India", dial_code: "+91", code: "IN" },
  ].map((obj) => ({
    label: obj?.dial_code,
    value: obj?.dial_code,
  }));

  const {
    value: value,
    isValid: isValidvalue,
    hasError: valueError,
    valueChangeHandler: valueChangeHandler,
    inputBlurHandler: valueBlurHandler,
  } = useInput(validatePhoneNumber);

  const {
    value: email,
    isValid: isValidEmail,
    hasError: emailError,
    valueChangeHandler: emailChangeHandler,
    inputBlurHandler: emailBlurHandler,
  } = useInput(validateEmail);

  const { sendRequest: signInUser, isLoading } = useApiHttp();
  const { sendRequest: sendEmailOtp, isLoading: isEmailLoading } = useApiHttp();
  const isValidForm = !isValidvalue;

  const setPhoneValue = (phoneNumber) => {
    valueChangeHandler({
      target: {
        type: "number",
        value: phoneNumber,
      },
    });
  };

  const sanitizePhoneNumber = (inputValue) => {
    const digits = inputValue.replace(/\D/g, "");

    if (digits.length > 10 && digits.startsWith("91")) {
      return digits.slice(-10);
    }

    return digits.replace(/^0+/, "").slice(0, 10);
  };

  const handlePhoneChange = (event) => {
    setPhoneValue(sanitizePhoneNumber(event.target.value));
  };

  const handlePhonePaste = (event) => {
    const pastedValue = event.clipboardData.getData("text");
    const phoneNumber = sanitizePhoneNumber(pastedValue);

    if (!phoneNumber) return;

    event.preventDefault();
    setPhoneValue(phoneNumber);
  };

  const handleEmailPaste = (event) => {
    const pastedEmail = event.clipboardData.getData("text").trim();

    if (!pastedEmail) return;

    event.preventDefault();
    emailChangeHandler({
      target: {
        type: "email",
        value: pastedEmail,
      },
    });
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    const countryCode = countryCodeItems.filter((items, index) => {
      if (index == selectedCountry) {
        return items;
      }
    })[0]?.value;

    signInUser(
      {
        base: "JCAPI",
        isBearer: false,
        url: `account/jioid/sendotp`,
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "X-Api-Key": process.env.REACT_APP_APIKEY,
          "X-App-Secret": process.env.REACT_APP_APPSECRET,
          "X-Client-Details": process.env.REACT_APP_CLIENTDETAILS,
          "X-Device-Type": process.env.REACT_APP_DEVICETYPE,
        },
        body: {
          mobileNumber: "+91" + value,
        },
      },
      null,
      (data) => {
        setAuthData({
          channel: "mobile",
          phoneNumber: value,
          countryCode,
          identifier: data?.data?.identifier,
        });
        Notifications.toast.success({ id: "sign-in", title: "OTP Send" });
      },
      (err, data) => {
        Notifications.toast.error({ id: "sign-in", title: data.error });
      },
    );
  };

  const handleEmailSubmit = (e) => {
    e?.preventDefault();
    const normalizedEmail = email.trim();
    if (!validateEmail(normalizedEmail)) {
      // setEmailError(true);
      return;
    }
    // setEmailError(false);
    sendEmailOtp(
      {
        base: "JCAPI",
        isBearer: false,
        url: `account/login/otp/send `,
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "X-Api-Key": process.env.REACT_APP_APIKEY,
          "X-App-Secret": process.env.REACT_APP_APPSECRET,
          "X-Client-Details": process.env.REACT_APP_CLIENTDETAILS,
          "X-Device-Type": process.env.REACT_APP_DEVICETYPE,
          "X-Device-Key": deviceKey,
        },
        body: { emailId: normalizedEmail },
      },
      null,
      () => {
        setAuthData({ channel: "email", email: normalizedEmail });
        Notifications.toast.success({ id: "email-sign-in", title: "OTP Send" });
      },
      (_, data) => {
        Notifications.toast.error({ id: "email-sign-in", title: data.error });
      },
    );
  };

  useEffect(() => {
    setDeviceKey(uuidv4());
  }, []);

  useEffect(() => {
    if (!emailMode) {
      phoneInputRef.current?.focus();
    }
  }, [emailMode]);

  if (authData) {
    return (
      <Otp
        authData={authData}
        onBack={() => {
          setAuthData(null);
          if (authData.channel === "email") setEmailMode(true);
        }}
        deviceKey={deviceKey}
        handleEmailSubmit={handleEmailSubmit}
        handleSubmit={handleSubmit}
      />
    );
  }

  return (
    <>
      <AuthCard title="in">
        {emailMode ? (
          <form onSubmit={handleEmailSubmit} key={"email-form"}>
            <Container
              direction="column"
              style={{ marginTop: "48px" }}
              gap={68}
              fullWidth
              horizontalAlign="center">
              <InputField
                type="email"
                label="Email ID"
                name="email"
                value={email}
                onChange={emailChangeHandler}
                onPaste={handleEmailPaste}
                onBlur={emailBlurHandler}
                state={emailError ? "error" : ""}
                stateText="Enter a valid email address"
              />

              <Button
                type="submit"
                fullWidth
                disabled={!isValidEmail || isEmailLoading}
                kind={isEmailLoading ? "secondary" : "primary"}
                size="large"
                label="Sign in">
                {isEmailLoading ? (
                  <Spinner kind="vibrant" label="Loading..." size="small" />
                ) : (
                  "Get OTP"
                )}
              </Button>

              <Button
                type="button"
                kind="tertiary"
                label="Sign in using Phone Number"
                onClick={() => setEmailMode(false)}
              />
            </Container>
          </form>
        ) : (
          <form onSubmit={handleSubmit} key={"phone-form"}>
            <Container
              direction="column"
              style={{ marginTop: "48px" }}
              gap={68}
              fullWidth
              horizontalAlign="center">
              <TextField
                variant="standard"
                fullWidth
                type="tel"
                value={value}
                onChange={handlePhoneChange}
                onPaste={handlePhonePaste}
                onBlur={valueBlurHandler}
                error={valueError}
                placeholder="Phone number"
                name="phoneNumber"
                helperText={valueError ? "Invalid phone number" : ""}
                FormHelperTextProps={{
                  className: "signin-phone-helper-text",
                }}
                inputProps={{
                  inputMode: "numeric",
                  maxLength: 10,
                }}
                inputRef={phoneInputRef}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <span className="signin-phone-prefix">
                        {countryCodeItems[selectedCountry]?.label}
                        <KeyboardArrowDownIcon fontSize="small" />
                      </span>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiInput-root": {
                    minHeight: "40px",
                    fontFamily: "var(--font-medium)",
                    color: "#595959",
                  },
                  "& .MuiInput-root:before": {
                    borderBottomColor: "#d6d6d6",
                  },
                  "& .MuiInput-root:hover:not(.Mui-disabled):before": {
                    borderBottomColor: valueError ? "#e30513" : "#707070",
                  },
                  "& .MuiInput-root:after": {
                    borderBottomColor: valueError ? "#e30513" : "#0078ad",
                  },
                  "& .MuiInput-root.Mui-error:before, & .MuiInput-root.Mui-error:after":
                    {
                      borderBottomColor: "#e30513",
                    },
                  "& .MuiInputBase-input": {
                    fontFamily: "var(--font-medium)",
                    fontSize: "16px",
                    color: "#595959",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#595959",
                    opacity: 1,
                  },
                }}
              />
              <Button
                type="submit"
                fullWidth
                disabled={isValidForm || isLoading}
                kind={isLoading ? "secondary" : "primary"}
                size="large"
                label="Sign in">
                {isLoading ? (
                  <Spinner kind="vibrant" label="Loading..." size="small" />
                ) : (
                  "Get OTP"
                )}
              </Button>
              <Button
                type="button"
                kind="tertiary"
                label="Sign in using Email"
                onClick={() => setEmailMode(true)}
              />
            </Container>
          </form>
        )}
      </AuthCard>
    </>
  );
}
